import React from 'react'
import LaunchHome from '../../components/Launchpad/home'


export default function Launchpad(){
  return (<>
    <LaunchHome></LaunchHome>
    </>)
}